import { useCallback } from 'react';

import { ChooseBankBase } from '@perpay-web/fintech/components/composite/ChooseBankBase/ChooseBankBase';
import { BankAccount } from '@perpay-web/fintech/reducers/entities/banks';
import { noop } from '@perpay-web/utils/noop';

type ChooseBankProps = {
    onChange?: (bank: BankAccount | undefined) => void;
    onBack?: VoidFunction;
    buttonTheme?: 'card';
    skipMFA?: boolean;
};

const ChooseBank = ({
    onChange = noop,
    onBack = noop,
    buttonTheme = undefined,
    skipMFA = undefined,
}: ChooseBankProps) => {
    const handleSelectBankAccount = useCallback(
        (bank: BankAccount | undefined) => {
            onChange(bank);
        },
        [onChange],
    );

    return (
        <ChooseBankBase
            onBack={onBack}
            onSuccess={(bank: BankAccount | undefined) => {
                handleSelectBankAccount(bank);
                onBack();
            }}
            buttonTheme={buttonTheme}
            skipMFA={skipMFA}
        />
    );
};

export default ChooseBank;
